<nav class="bg-transparent p-6 flex items-center justify-between">
  <div class="flex items-center gap-4">
  </div>

  <div class="flex items-center gap-4">
    <div class="relative w-80">
      <label class="sr-only" for="navBuildingSearch">Building</label>
      <div class="relative">
        <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
          <lucide-icon [img]="icons.Search" [size]="16"></lucide-icon>
        </span>
        <input
          id="navBuildingSearch"
          type="text"
          autocomplete="off"
          [placeholder]="loading() ? 'Loading buildings…' : 'Select a building…'"
          [disabled]="loading()"
          [ngModel]="query()"
          (ngModelChange)="query.set($event); dropdownOpen.set(true)"
          (focus)="openDropdown()"
          (blur)="closeDropdownSoon()"
          class="w-full pl-9 pr-9 py-2 text-sm bg-gray-50 border border-gray-300 rounded-md focus:ring-violet-400 focus:border-violet-400 disabled:opacity-60" />
        <button
          *ngIf="buildingContext.selected()"
          type="button"
          (mousedown)="$event.preventDefault(); clear()"
          class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
          <lucide-icon [img]="icons.X" [size]="16"></lucide-icon>
        </button>
      </div>

      <div
        *ngIf="dropdownOpen() && filtered().length > 0"
        class="absolute z-30 mt-1 w-full max-h-72 overflow-y-auto bg-white border border-gray-200 rounded-md shadow-lg">
        <ul class="py-1 text-sm text-gray-700">
          <li
            *ngFor="let b of filtered()"
            (mousedown)="$event.preventDefault(); pick(b)"
            class="px-3 py-2 cursor-pointer hover:bg-purple-100">
            {{ b.name }}
            <span class="text-gray-400 text-xs ml-1">#{{ b.id }}</span>
          </li>
        </ul>
      </div>

      <div
        *ngIf="dropdownOpen() && !loading() && filtered().length === 0"
        class="absolute z-30 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg px-3 py-2 text-xs text-gray-500">
        No buildings match.
      </div>
    </div>
  </div>
</nav>
